import moment from "moment";

export default class CourseGroup {
    constructor(data) {
        this.modelFields = ["id", "name", "price", "startDate", "endDate", "teacherId", "courseType", "isHidden", "vkUrl", "performanceTableUrl",
            "lessonsCount", "timetable", "firstLessonDate", "lastLessonDate", "headTeacherId", "mainChat", "additionalChat"];
        this.updateData(data);
        this.enrollments = !data ? [] : data.enrollments;
        this.isEditing = false;
    }

    getDisplayName() {
        let courseTypeName = window.AcademIt.CourseType.getDisplayName(this.courseType);
        if (this.courseType === window.AcademIt.CourseType.Unknown.value && this.name) {
            courseTypeName = this.name;
        }

        const dateString = moment(this.startDate).format("MMMM YYYY");
        return `${courseTypeName}, ${dateString}`;
    }

    getDisplayDate() {
        return moment(this.startDate).format("MMMM YYYY");
    }

    updateData(data) {
        if (!data) {
            this.modelFields.forEach(f => this[f] = null);
            this.isHidden = false;
            return;
        }

        this.modelFields.forEach(f => this[f] = data[f]);
    }
    
    copyTo(data) {
        this.modelFields.forEach(f => data[f] = this[f]);
    }
}